
import { motion } from 'framer-motion';
import { useInView } from '../../../hooks/useInView';

const ValueProposition = () => {
  const [ref, isInView] = useInView({ threshold: 0.2 });

  const capabilities = [
    {
      icon: 'ri-global-line',
      title: 'Global Sourcing Network',
      description: 'Direct access to thousands of verified manufacturers worldwide, ensuring competitive wholesale pricing and quality control at the source.',
    },
    {
      icon: 'ri-truck-line',
      title: 'End-to-End Logistics',
      description: 'Complete supply chain coordination from factory to jobsite, including shipping, tracking, and delivery management across all major ports.',
    },
    {
      icon: 'ri-file-shield-line',
      title: 'Customs & Compliance',
      description: 'In-house customs clearance expertise in Canada and the United States, plus documentation support for international deliveries worldwide.',
    },
  ];

  return (
    <section ref={ref} className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <div className="text-xs font-semibold text-secondary-600 tracking-widest uppercase mb-4">
            GLOBAL CAPABILITIES
          </div>
          <h2 className="font-display font-light text-4xl md:text-5xl lg:text-6xl text-gray-900 max-w-4xl">
            Simplifying Construction Supply Chains{' '}
            <span className="font-semibold">Worldwide</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {capabilities.map((capability, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: index * 0.15, duration: 0.6 }}
              className="bg-gray-50 rounded-2xl p-8 border border-gray-100 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-primary-500 to-primary-700 rounded-xl mb-6">
                <i className={`${capability.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="font-display font-semibold text-xl text-gray-900 mb-3">
                {capability.title}
              </h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                {capability.description}
              </p>
              <a href="#" className="inline-flex items-center text-sm font-medium text-secondary-600 hover:text-secondary-700 transition-colors cursor-pointer">
                Learn more
                <i className="ri-arrow-right-line ml-1"></i>
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValueProposition;
